import styled from '@emotion/styled';
import { Paragraph1 } from 'inpock-ui-react';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconCart from '@/assets/icons/icon-cart.svg';

export const Wrapper = styled.nav`
  position: relative;
  padding: -1px 10px;
  margin: 0 auto;
  width: 100%;
`;

export const Container = styled.div<{ borderBottom?: boolean }>`
  position: fixed;
  width: 100%;
  max-width: inherit;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 4px;
  z-index: 999;
  top: 0;
  transition: transform 0.3s ease-in-out;
  background-color: white;

  &.hidden {
    transform: translateY(-100%);
  }

  border-bottom: ${(props) => (props.borderBottom ? `1px solid ${colors.gray200}` : null)};

  @media (min-width: 600px) {
    max-width: 450px;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-left: 6px;
`;

export const MarketLogoText = styled(Paragraph1)`
  font-size: 18px;
`;

export const MarketLogoImage = styled.img`
  height: 22px;
  object-fit: contain;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-right: 12px;
`;

export const BtnCartContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

export const BtnCart = styled.div`
  padding: 8px;
  cursor: pointer;
  background-image: url(${IconCart});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 17px;
  height: 22px;
`;

export const CartCount = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${colors.orange800};
  right: -8px;
  top: -4px;
  display: flex;
  justify-content: center;
`;
